import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pin_2DjU0",
  "use": "pin_2DjU0-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pin_2DjU0\">\n    <path d=\"M12 2c-4 0-7 3-7 7 0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z\" stroke=\"currentColor\" fill=\"none\" />\n    <circle cx=\"12\" cy=\"9\" r=\"2.5\" stroke=\"currentColor\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol